<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-flex tag="h2" v-if="!champsLeftPanel" data-qe-id="Manage_My_Quick_LinkDialog">
                    {{ myToolsConstants.QUICK_LINKS.Manage_My_Quick_Links }}
                    <v-btn @click="closeDialogBox" data-qe-id="quickLinkDialog_closeBtn" icon>
                        <v-icon size="25" data-qe-id="quickLinkDialog_CloseIcon">close</v-icon>
                    </v-btn>
                </v-flex>
                <v-layout row wrap class="quick-links-popup__container">
                    <v-flex xs5 sm3>
                        <quick-side-layout
                            :category-list="editableCategoryList"
                            :my-quick-links-length="editableQuickLinks.length"
                            :selected-category="selectedCategory"
                            :selected-category-handler="updateSelectedCategory"
                        >
                        </quick-side-layout>
                    </v-flex>
                    <v-flex xs7 sm9>
                        <quick-links-category
                            :can-save="hasChanges"
                            :handle-add-quick-link="addQuickLink"
                            :handle-hide-quick-link="hideQuickLink"
                            :handle-cancel="resetQuickLinks"
                            :handle-save="saveNewLinks"
                            :my-quick-links-length="editableQuickLinks.length"
                            :selected-category="selectedCategory"
                            :handle-edited-quick-links="updateQuickLinksForSave"
                            :close-quick-link-dialog="closeQuickLinkDialog"
                        >
                        </quick-links-category>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import QuickSideLayout from './QuickSideLayout';
import QuickLinksCategory from './QuickLinksCategory';
import { mapActions, mapGetters } from 'vuex';
import { storeGetters } from '../../../store/storeGetters.constant';
import { addOrderToList, myToolsConstants } from '../mytools.constant';
import { storeAction } from '../../../store/storeActions.constant';

export default {
    name: 'QuickLinkDialog',
    data: () => ({
        editableQuickLinks: null,
        editableCategoryList: null,
        selectedCategory: null,
        myToolsConstants,
    }),
    created() {
        this.editableQuickLinks = [...this.myQuickLinks];
        this.editableCategoryList = [...this.categoryMaster];
        this.selectedCategory = this.categoryMaster && this.categoryMaster[0] ? { ...this.categoryMaster[0] } : null;
        if (this.selectedCategory) {
            this.selectedCategory = {
                ...this.selectedCategory,
                links: [...this.myQuickLinks],
            };
        }
    },
    components: {
        QuickSideLayout,
        QuickLinksCategory,
    },
    props: {
        closeQuickLinkDialog: {
            type: Function,
            required: true,
        },
        champsLeftPanel: {
            type: Boolean,
        },
    },
    methods: {
        ...mapActions({
            saveQuickLinks: `tools/${storeAction.saveQuickLinks}`,
        }),
        closeDialogBox() {
            this.resetQuickLinks();
            this.closeQuickLinkDialog();
        },
        updateSelectedCategory(category) {
            this.selectedCategory = category || null;
            if (category.key === myToolsConstants.QUICK_LINKS.QuickLinks) {
                this.selectedCategory = {
                    ...this.selectedCategory,
                    links: [...this.editableQuickLinks],
                };
            }
        },
        updateQuickLinksForSave(links) {
            this.editableQuickLinks = [...links];
        },
        hideQuickLink(quickLink) {
            const categoryIndex = this.editableCategoryList.indexOf(
                this.editableCategoryList.find((item) => item.key.toLowerCase() === quickLink.label.toLowerCase()),
            );

            if (this.editableCategoryList[categoryIndex]) {
                this.editableCategoryList[categoryIndex] = {
                    ...this.editableCategoryList[categoryIndex],
                    links: [{ ...quickLink }, ...this.editableCategoryList[categoryIndex].links],
                };
            }
        },
        addQuickLink(quickLink) {
            const categoryIndex = this.editableCategoryList.indexOf(
                this.editableCategoryList.find((item) => item.key.toLowerCase() === quickLink.label.toLowerCase()),
            );

            if (this.editableCategoryList[categoryIndex]) {
                this.editableCategoryList[categoryIndex] = {
                    ...this.editableCategoryList[categoryIndex],
                    links: this.editableCategoryList[categoryIndex].links.filter((item) => item.id !== quickLink.id),
                };
            }

            this.editableQuickLinks = [
                {
                    ...quickLink,
                    isAdded: !quickLink.hasOwnProperty('personId'),
                },
                ...this.editableQuickLinks,
            ];
        },
        resetQuickLinks() {
            this.editableQuickLinks = addOrderToList([...this.myQuickLinks]);
            this.editableCategoryList = [...this.categoryMaster];

            const resetSelectedCategory = this.categoryMaster.find((item) => item.key === this.selectedCategory.key);

            this.selectedCategory = { ...resetSelectedCategory };
            if (this.selectedCategory.key === myToolsConstants.QUICK_LINKS.QuickLinks) {
                this.selectedCategory = {
                    ...this.selectedCategory,
                    links: [...this.editableQuickLinks],
                };
            }
        },
        saveNewLinks() {
            const quickLinkPayload = [];
            let iconOrder = 1;
            this.editableQuickLinks.forEach((quickLink) => {
                quickLink.iconOrder = iconOrder;
                quickLinkPayload.push(quickLink);
                iconOrder += 1;
            });
            this.saveQuickLinks(quickLinkPayload).then(() => {
                this.closeQuickLinkDialog();
            });
        },
    },
    computed: {
        ...mapGetters({
            myQuickLinks: `tools/${storeGetters.myQuickLinks}`,
            categoryMaster: `tools/${storeGetters.categoryMaster}`,
        }),
        hasChanges() {
            let result = false;
            if (this.editableQuickLinks && this.myQuickLinks) {
                if (this.editableQuickLinks.length !== this.myQuickLinks.length) {
                    result = true;
                } else {
                    this.editableQuickLinks.forEach((item) => {
                        if (this.editableQuickLinks.indexOf(item) !== this.myQuickLinks.indexOf(item)) {
                            result = true;
                        }
                    });
                }
            }
            return result;
        },
    },
};
</script>
